import React from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

export default function NotFoundPage() {
  const location = useLocation();

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, borderRadius: 3, border: "1px solid", borderColor: "divider" }}>
        <Typography variant="h5" sx={{ fontWeight: 900, mb: 1 }}>
          페이지를 찾을 수 없어요
        </Typography>

        <Typography sx={{ color: "text.secondary", mb: 2 }}>
          요청하신 경로가 존재하지 않습니다.
        </Typography>

        <Typography sx={{ fontSize: 13, color: "text.secondary", mb: 3 }}>
          현재 경로: <b>{location.pathname}</b>
        </Typography>

        <Stack direction="row" spacing={1}>
          <Button variant="contained" component={RouterLink} to="/">
            대시보드로
          </Button>
          <Button variant="outlined" onClick={() => window.history.back()}>
            뒤로가기
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
